module.exports = __webpack_public_path__ + "static/media/bv.2ba685bf.webp";